import React, { useMemo } from 'react';

import { Stack, StackProps } from '@lyearn/ui';

import MediaContextProvider from '../context';
import { MediaContextProps } from '../types';

const Media = (props: MediaContextProps & StackProps) => {
  const { media, children, ...rest } = props;
  const value = useMemo(() => ({ media }), [media]);

  return (
    <MediaContextProvider media={value.media}>
      <Stack {...rest}>{children}</Stack>
    </MediaContextProvider>
  );
};

export default Media;
